import type React from 'react'
import { useState, useEffect } from 'react'
import styled from 'styled-components'

interface Props {
  onChange: (newSharecode: string) => void
  value: string
}

const TextInputContainer = styled.div`
  width: 100%;
  display: grid;
  align-items: center;
  justify-content: center;
  grid-template-columns: repeat(auto-fit, minmax(50px, 1fr));
  grid-gap: 10px;
`

const TextInputLabel = styled.span``

const SectionInput = styled.input`
  padding: 10px;
  border-radius: 10px;
  outline: none;
  text-transform: uppercase;
  width: fit-content;
  text-align: center;
  width: 100%;
`

const TextInput: React.FC<Props> = ({ onChange, value }) => {
  const [firstPart, setFirstPart] = useState<string>('')
  const [secondPart, setSecondPart] = useState<string>('')
  const [thirdPart, setThirdPart] = useState<string>('')

  useEffect(() => {
    const fullShareCode = `${firstPart} ${secondPart} ${thirdPart}`

    if (
      fullShareCode.trim() !== '' &&
      fullShareCode.length === 11 &&
      fullShareCode !== value
    ) {
      onChange(fullShareCode)
    }
  }, [firstPart, secondPart, thirdPart, onChange, value])

  useEffect(() => {
    const parts = value.split(' ')

    setFirstPart(parts[0])
    setSecondPart(parts[1])
    setThirdPart(parts[2])
  }, [value])

  const adjustFocus = (e: React.ChangeEvent<HTMLInputElement>) => {
    const length = e.target.value.length

    if (e.target.nextElementSibling && length === 3) {
      ;(e.target.nextElementSibling as HTMLInputElement)?.focus()
    } else if (e.target.previousElementSibling && length === 0) {
      ;(e.target.previousElementSibling as HTMLInputElement)?.focus()
    }
  }

  const sanitizeInput = (input: string) => {
    return input
      .replace(/[^\w\s]/gi, '')
      .trim()
      .toUpperCase()
  }

  return (
    <div>
      <TextInputLabel>Share code</TextInputLabel>
      <TextInputContainer>
        <SectionInput
          maxLength={3}
          minLength={3}
          type="text"
          onChange={e => {
            setFirstPart(sanitizeInput(e.target.value))
            adjustFocus(e)
          }}
          pattern="^[a-zA-Z0-9]+$"
          value={firstPart}
          data-testid="first-part"
        />
        <SectionInput
          maxLength={3}
          minLength={3}
          type="text"
          onChange={e => {
            setSecondPart(sanitizeInput(e.target.value))
            adjustFocus(e)
          }}
          pattern="^[a-zA-Z0-9]+$"
          value={secondPart}
          data-testid="second-part"
        />
        <SectionInput
          maxLength={3}
          minLength={3}
          type="text"
          onChange={e => {
            setThirdPart(sanitizeInput(e.target.value))
            adjustFocus(e)
          }}
          pattern="^[a-zA-Z0-9]+$"
          value={thirdPart}
          data-testid="third-part"
        />
      </TextInputContainer>
    </div>
  )
}

export default TextInput
